import React from 'react';

import {Icon} from '@albert-io/atomic';
import {history} from 'client/history';

import {ActionCard} from './ActionCard';

interface TileProps {
  description?: string;
  horizontal?: boolean;
}

export const CreateAssignmentTile = ({description, horizontal}: TileProps) => (
  <ActionCard
    data-testid='home-action__new-assignment'
    description={description}
    horizontal={horizontal}
    iconClassName='background-dragonfruit-subtle content-dragonfruit'
    iconContent={<Icon color='inherit' icon='file-lines' iconStyle='light' size='inherit' />}
    onClick={() => history.pushState(null, '/assignment-builder/create-assignment')}
    title='Create assignment'
  />
);

export const BrowseSubjectsTile = ({description, horizontal}: TileProps) => (
  <ActionCard
    data-testid='home-action__browse-subjects'
    description={description}
    horizontal={horizontal}
    iconClassName='background-pineapple-subtle content-pineapple'
    iconContent={<Icon color='inherit' icon='books' iconStyle='light' size='inherit' />}
    onClick={() => history.pushState(null, '/subjects')}
    title='Browse Subjects'
  />
);
